<script>
    import PostCard from '../components/PostCard.svelte'
    import AddressForm from '../components/AddressForm.svelte'
    import firebase from 'firebase/app'
    import FaAddressCard from 'svelte-icons/fa/FaAddressCard.svelte'
    import FaShoppingBag from 'svelte-icons/fa/FaShoppingBag.svelte'
    import {get} from 'svelte/store'
    import {writable, readable, derived} from 'svelte-persistent-store/dist/local'
    import AddressView from '../components/AddressView.svelte'
    import Banner from '../components/Banner.svelte'
    import {slide} from 'svelte/transition'
    import {navigate} from 'svelte-routing'
    import {loadStripe} from '@stripe/stripe-js'
    import FaPlus from 'svelte-icons/fa/FaPlus.svelte'
    import {cartStore} from '../model/stores'
    import PriceView from '../components/PriceView.svelte'
    import OrderSummaryView from '../components/OrderSummaryView.svelte'
    import NetworkButton from '../components/NetworkButton.svelte'
    import {
        emitHttpExceptionEvent,
        emitPageViewEvent,
        getBasicPostcardDetails,
        getBasicPostcardItem
    } from '../actions/pageAnalytics'

    export let location
    const stripePromise = loadStripe('__STRIPE_PK__')
    const createOrders = firebase.functions().httpsCallable('createOrders')
    let orders = $cartStore
    let errorMessage
    let erroredOrders = orders.map(it => false)
    window.scrollTo(0, 0)

    let totalPrice
    $:totalPrice = orders.reduce((acc, it) => acc + it.price, 0)
    emitPageViewEvent(location, 'Checkout')
    firebase.analytics().logEvent('view_cart', orders.map(it => getBasicPostcardDetails(it)))

    async function onOrderCreated(res) {
        if (res.data.transactionId) {
            firebase.analytics().logEvent('purchase', {
                currency: 'USD',
                items: orders.map(it => getBasicPostcardItem(it)),
                payment_type: 'free',
                value: 0,
                transaction_id: res.data.transactionId
            })
            cartStore.set([])
            navigate(`/thankyou?transactionId=${res.data.transactionId}&estimatedDeliveryDate=${res.data.estimatedDeliveryDate}`)
        } else if (res.data.stripeSessionId) {
            firebase.analytics().logEvent('begin_checkout', {
                currency: 'USD',
                value: totalPrice,
                items: orders.map(it => getBasicPostcardItem(it)),
                sessionId: res.data.stripeSessionId
            })
            const stripe = await stripePromise
            const {error} = await stripe.redirectToCheckout({
                sessionId: res.data.stripeSessionId
            })
            throw error
        }
    }

    async function confirmOrder() {
        errorMessage = undefined
        await createOrders(orders).then(onOrderCreated).catch(e => {
            errorMessage = e.message
            emitHttpExceptionEvent(e)
            if (e.details) {
                erroredOrders = e.details.map(it => Object.keys(it).length > 0)
            }
        })
    }


    function clearCart() {
        $cartStore.set({})
    }

    function addACard() {
        navigate('/new')
    }

    function removeFromCart(orderIndex) {
        const order = $cartStore[orderIndex]
        cartStore.update(it => {
            it.splice(orderIndex, 1)
            return it
        })
        orders = $cartStore
        firebase.analytics().logEvent('remove_from_cart', getBasicPostcardDetails(order))
    }


</script>

<style>
    h1 {
        text-align: left;
        line-height: 1.1em;
        font-weight: bold;
    }

    .right-col {
        display: flex;
        flex-direction: column;
        max-width: 25em;
        flex: none;
    }

    .left-col {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .payMark {
        height: 2rem;
    }

    @media (max-width: 60em) {
        .row {
            flex-direction: column;
        }

        .vr {
            display: none;
        }

        .right-col {
            margin-top: 1rem;
        }

        .parent {
            max-width: 25rem;
            align-self: center;
        }
    }
</style>
<div class="flex flex-column relative" out:slide>

    <Banner cl='warning mt1'>
        Due to COVID-19, USPS has increased their shipping estimates from <b>1-3</b> Business days to <b>2-4</b> business days.
        <a style='color:#975A16' href='https://postalpro.usps.com/node/8016' title='USPS Covid-19 statement'>Learn more</a><br><br>
        Thank you for your understanding. ❤️
    </Banner>
    <div class="parent flex flex-column">
        {#if orders.length > 0}
            <div class="row flex mt2 mb4">
                <div class="left-col">
                    {#each orders as order, orderIndex }
                        <OrderSummaryView {order} {orderIndex} {removeFromCart} isError={erroredOrders[orderIndex]}/>
                    {/each}
                    <button on:click={addACard}><span class="icon small"><FaPlus/></span> Add another card</button>
                    <!--                    <h5 class='clickable mt1 nearInkText' on:click={clearCart}>Clear all items</h5>-->
                </div>
                <div class="vr flex-none"></div>
                <div class="right-col self-start">
                    <div class="flex flex-column items-center py4 flex-auto">
                        <h3 class="flex-auto mb1">Total:</h3>
                        <h1 class='bold'>${ (totalPrice ? totalPrice / 100: 0).toFixed(2)} USD</h1>
                    </div>
                    <NetworkButton action={confirmOrder} cl='mb1'>
                        {#if totalPrice === 0}
                            Confirm
                        {:else}
                            Pay ${(totalPrice/100).toFixed(2)} USD
                        {/if}
                    </NetworkButton>
                    {#if errorMessage}
                        <Banner cl='error' animate={true}>{errorMessage}</Banner>
                    {/if}
                    <hr class='my1'>
                    <card class="flex flex-column payment my1">
                        <h4 class='center mb2'>We accept all forms of payment.</h4>
                        <div class="flex justify-center mt1">
                            <img class='payMark mr1' src="res/ApplePayMark.svg" alt="Apple Pay is accepted.">
                            <img class='payMark mr1' src="res/GooglePayMark.svg" alt="Google Pay is accepted.">
                            <img class='payMark' src="res/powered_by_stripe.svg" alt="Powered by stripe.">
                        </div>
                    </card>
                    <Banner>
                        Items will be processed every week-day morning, and mailed via USPS First Class. Shipping will take 2-4 Business Days.
                    </Banner>
                </div>
            </div>
        {:else}
            <h2 class='center my4'>Your cart is empty.</h2>
        {/if}
    </div>
</div>
